import { useEffect, useState } from "react";
import heic2any from 'heic2any';
import FileType from "file-type/browser";
import { IMAGE_TYPES } from "shared/settings/config";
import { Button, Form, InputGroup, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import ReactQuill from "react-quill";
import { DokaImageEditor } from "react-doka";
import { getEditorDefaults } from 'shared/doka';
import { getAdminHeaders, getAdminUrl } from "shared/http";
import { adminContentList, generateNewStoriesContent, newsAndStoriesAdd, newsAndStoriesList, newsAndStoriesUpdate, shopWithPurposeBgImageAdd } from "shared/settings/apiconfig";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import './NewsAndStories.scss';

export const NewsAndStories = (props) => {
    const quillModules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: { matchVisual: false }
    };
    const today = new Date();
    const bgTargetImage = {width: 1150, height: 298 };
    const bgImageEditorDefaults = {
        imageCropAspectRatio: 1150 / 298,
        cropEnableSelectPreset: false,
        imageCropMinSize: { width: 1150, height: 298 },
    };
    const id = props.match.params.id;
    const requiredFieldsCustom = ["coverimage", "title", "summary", "htmlcontent", "publishername"];
    const requiredFieldsExternal = ["coverimage", "title", "summary", "storylink", "publishername"];

    const [tempBgImg, setTempBgImg] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [coverImg, setCoverImg] = useState('');
    const [coverImgName, setCoverImgName] = useState('');
    const [coverImgError, setCoverImgError] = useState({ show: false, type: '', msg: '' });
    const [contentData, setContentData] = useState({
        "coverimage": "",
        "title": "",
        "summary": "",
        "storylink": "",
        "referenceLink": "",
        "publishername": "",
        "publisheddate": "",
        "htmlcontent": "",
        "status": "",
        "effectivedate": ""
    });
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [previewModal, showPreviewModal] = useState(false);
    const [btnType, setBtnType] = useState(props?.location?.state?.type ? props.location.state.type : "yourself");
    const [radioBtnChecked, setRadioBtnChecked] = useState('');
    const [urlLink, setUrlLink] = useState('');
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [removeBlogLoading, setRemoveBlogLoading] = useState(false);
    const [btnActive, setBtnActive] = useState(props?.location?.state?.type ? props.location.state.type : "yourself");
    const [savedMsg, setSavedMsg] = useState({ show: false, type: '', msg: '' });
    const [descriptionModal, setDescriptionModal] = useState(false);
    const [descriptionContent, setDescriptionContent] = useState('');
    const [viewModal, showViewModal] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    // const [dateMsg, setDateMsg] = useState({ show: false, type: "", msg: "" });
    const [titleError, setTitleError] = useState('');
    const [summaryError, setSummaryError] = useState('');
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveLaterLoading, setSaveLaterLoading] = useState(false);

    useEffect(() => {
        if(id) {
            getNewsStoriesList(id);
        }
    },[id, btnType])

    const getNewsStoriesList = (id) => {
        let data = {
            "filter": [{ "field": "id", "value": id, "op": "=", "join": "AND" }],
            "page": { "size": 4, "pagenumber": 1 }
        }
        axios.post(getAdminUrl(adminContentList), data, getAdminHeaders()).then(response => {
            if (response.data.status == "success") {
                setContentData(prev => ({
                    ...prev,
                    ...response.data.data[0]
                }));
                setRadioBtnChecked(response.data.data[0].htmlcontent ? "custom" : response.data.data[0].storylink ? "external" : '');
                setPageLoading(false);
            }
        }).catch(error => {
            setPageLoading(false);
        })
    }
    
    const uploadCoverImage = () => {
        document.getElementById('coverimage').click();
    }

    const changeImage = async (event) => {
        let uploadedFile = event.target.files[0];
        setCoverImgError({ show: false, type: "", msg: "" })
        setCoverImgName(uploadedFile.name);
        if (!uploadedFile) return;

        let mimetype = await FileType.fromBlob(uploadedFile);
        let blob = null;
        let tempImgUrl = URL.createObjectURL(uploadedFile);
        
        let img = new Image();
        img.src = tempImgUrl;

        img.onload = async () => {
            if (img.width < 1150 || img.height < 298) {
                setCoverImgError({ show: true, type: "error", msg: "Please upload image with minimum size of 1100W x 250H pixels." });
                event.target.value = '';
                return;
            }

            if (mimetype?.mime === "image/heic" && mimetype?.ext === 'heic') {
                blob = await heic2any({
                    blob: uploadedFile,
                    toType: 'image/jpeg',
                    quality: 0.94,
                });
                
                tempImgUrl = URL.createObjectURL(blob);
            }

            setTempBgImg(tempImgUrl);
            setShowMediaModal(true);
            setCoverImg(tempImgUrl);
            
            event.target.value = '';
        }
    }
    const setNewsStoriesData = (type, value) => {
        const textOnly = value.replace(/<[^>]*>/g, ' ');
        const wordCount = textOnly.trim().split(/\s+/).filter(Boolean).length;
      
        // Define max limits
        const maxWords = type === 'title' ? 200 : 1000;
      
          setContentData(prev => ({
            ...prev,
            [type]: value
          }));
       
      
        // Set error only if limit exceeded
        if (type === 'title') {
          setTitleError(wordCount > maxWords ? "Maximum 200 words allowed" : '');
        } else if (type === 'summary') {
          setSummaryError(wordCount > maxWords ? "Maximum 1000 words allowed" : '');
        }
      };
    

    const cancelImage = () => {
        setTempBgImg(null);
        setShowMediaModal(false);
    }

    const setNewsStoriesBgData = (output) => {
        let reader = new FileReader();
        let base64 = null;

        reader.readAsDataURL(output.dest);
        reader.onload = () => {
            base64 = reader.result.split(',')[1];
            let payload = {
                url: base64,
                type: output.dest.type === 'application/pdf' ? 'pdf' : 'image'
            }

            axios.post(getAdminUrl(shopWithPurposeBgImageAdd), JSON.stringify({ data: payload }), getAdminHeaders()).then(response => {
                if (response.data.status == "success") {
                    setShowMediaModal(false);
                    setContentData(prev => ({
                        ...prev,
                        coverimage: response.data.data
                    }));
                }
            }).catch(error => {
                setCoverImgError({ show: true, type: "error", msg: error.response.data.message });
            })
        };
        setTempBgImg(null);
        setShowMediaModal(false);
    }

    const setUrlData = (event) => {
        setCoverImgError({ show: false, type: "", msg: "" })
        setUrlLink(event);
        setContentData(prev => ({
            ...prev,
            storylink: event
        }));
    }

    const getUrlData = (link) => {
        setSpinnerLoading(true);
        let data = {
            htmlcontent: link
        }
        axios.post(getAdminUrl(generateNewStoriesContent), {data: data}, getAdminHeaders()).then(response => {
            if (response.data.status == "success") {
                setContentData(prev => ({
                    ...prev,
                    ...response.data.data
                }));
                setSpinnerLoading(false);
            }
        }).catch(error => {
            setCoverImgError({ show: true, type: "error", msg: "No stories and articles to import from external" });
            setSpinnerLoading(false);
        })
    }

    const removeUrlData = () => {
        setRemoveBlogLoading(true);
        setUrlLink('');
        setContentData(prev => ({
            ...prev,
            coverimage: "",
            title: "",
            summary: "",
            storylink: "",
            referenceLink: "",
            publishername: "",
            publisheddate: "",
            htmlcontent: ""
        }));
        setRemoveBlogLoading(false);
    }

    const handleDateChange = (date) => {
        setSelectedDate(date);
        const hours = date.getHours();
        const minutes = date.getMinutes();

        const isTimeSelected = !(hours === 0 && minutes === 0);

        if (isTimeSelected) {
            setShowDatePicker(false);
            publishStories("schedule later", date);
        }
    };

    const publishStories = (type, date) => {
        if(type == "publish") {
            setSaveLoading(true);
        } else if (type == "schedule later") {
            setSaveLaterLoading(true);
        }
        const updatedContent = {
            ...contentData,
            publisheddate: moment().format('YYYY-MM-DD'),
            status: type === "draft" ? "draft" : type === "publish" ? "published" : type === "schedule later" ? "published" : '',
            effectivedate: type === "publish" ? moment(date).toISOString() : type === "schedule later" ? moment(date).toISOString() : "",
        };

        setContentData(updatedContent);

        const payload = updatedContent;

        if(contentData.id) {
            axios.post(getAdminUrl(newsAndStoriesUpdate), {data: payload}, getAdminHeaders()).then(response => {
                if (response.data.status == "success") {
                    if(type == "publish") {
                        setSaveLoading(false);
                    } else if (type == "schedule later") {
                        setSaveLaterLoading(false);
                    }
                    setSavedMsg({ show: true, type: "success", msg: 'News And Stories content is saved successfully' });
                    setTimeout(() => {
                        setSavedMsg({ show: false, type: '', msg: '' });
                        props.history.push('/ctbids-content/news-and-stories/list');
                    }, 3000);   
                }
            }).catch(error => {
                setSavedMsg({ show: true, type: "error", msg: error.response.data.message });
                setSaveLoading(false);
                setSaveLaterLoading(false);
            })
        } else {
            axios.post(getAdminUrl(newsAndStoriesAdd), {data: payload}, getAdminHeaders()).then(response => {
                if(type == "publish") {
                    setSaveLoading(false);
                } else if (type == "schedule later") {
                    setSaveLaterLoading(false);
                }
                setSavedMsg({ show: true, type: "success", msg: 'News And Stories content is saved successfully' });
                setTimeout(() => {
                    setSavedMsg({ show: false, type: '', msg: '' });
                    props.history.push('/ctbids-content/news-and-stories/list');
                }, 3000);
            }).catch(error => {
                setSavedMsg({ show: true, type: "error", msg: error.response.data.message });
                setSaveLoading(false);
                setSaveLaterLoading(false);
            })
        }
    }

    const previewStories = () => {
        showPreviewModal(true);
    }

    const cancelStories = () => {
        setContentData(prev => ({
            ...prev,
            coverimage: "",
            title: "",
            summary: "",
            storylink: "",
            referenceLink: "",
            publishername: "",
            publisheddate: "",
            htmlcontent: ""
        }));
        setSavedMsg({ show: false, type: '', msg: '' });
        setCoverImg('');
        setBtnType("yourself");
        setBtnActive("yourself");
        setUrlLink('');
        props.history.goBack();
    }

    const radiobtnChange = (type) => {
        setRadioBtnChecked(type)
        if(type == "custom") {
            setContentData(prev => ({
                ...prev,
                storylink: ""
            }));
        } else {
            if (type == "external") {
                setContentData(prev => ({
                    ...prev,
                    htmlcontent: ""
                }));
            }
        }
    }

    const onChangeDescriptionContent = (event) => {
        setDescriptionContent(event)
    }

    const saveDescription = () => {
        setContentData(prev => ({ 
            ...prev, 
            htmlcontent: descriptionContent
        }));
        setDescriptionContent('');
        setDescriptionModal(false);
    }

    const cancelDescription = () => {
        setDescriptionContent('');
        setDescriptionModal(false);
        setContentData(prev => ({ 
            ...prev, 
            htmlcontent: contentData.htmlcontent
        }));
    }

    const navigateToList = () => {
        props.history.push({ pathname: `/ctbids-content/news-and-stories/list`,state: props.location.state  });
    };

    const isToday = selectedDate ? selectedDate.toDateString() === today.toDateString() : false;

     const filterPassedTime = (time) => {
        if (!isToday) return true;
        const selectedTime = new Date(time);
        return selectedTime.getTime() > today.getTime();
    };

    const isFormValid = (radioBtnChecked == 'custom' ? requiredFieldsCustom : requiredFieldsExternal).every(field => contentData[field] && contentData[field] !== "");

    return (
        pageLoading ?
            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
            </div> : 
            
            <div className="featured-container h-100">
                <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                    <span onClick={navigateToList} className="clickable">
                        <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                        <span style={{ paddingLeft: "1em" }}>Back</span>
                    </span>
                </div>
                <h3 className='font-weight-bold px-5 mt-3 mobile-px-5'>News And Stories</h3>
                <div className="px-5 mt-3 mobile-px-5">
                    <div className="d-flex justify-content-between">
                        <h5 className='font-weight-bold'>Create stories and articles by {btnType == "external" ? "importing from external sites" : "yourself" }</h5>
                    </div>
                    {btnType == "yourself" ? <div className="w-100 d-flex align-items-center bg-white py-3 clickable">
                        <Form className="mobile-input" style={{ width: "50%" }}>
                            <InputGroup>
                                <Form.Control type="text" placeholder="Add cover image" value={ coverImgName ? coverImgName : contentData.coverimage } style={{ backgroundColor: "white", borderRadius: "5px" }} />
                                <Form.Control id="coverimage" type="file" name="BgImage upload" accept={IMAGE_TYPES} hidden onChange={(event) => { changeImage(event) }} />
                                <div className="d-flex align-items-center">
                                    <Button className="clickable" id="coverimage" style={{ marginLeft: "10px", borderRadius: "5px" }} onClick={uploadCoverImage}>Browse</Button>
                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                        {'This is the largest image to display, please use 1100W x 250H size image, in Landscape Mode.”'}</Tooltip>}>
                                        <i className={`fa fa-question-circle`} style={{ fontSize: "21px", marginLeft: "5px", marginTop: '1.5px' }}></i>
                                    </OverlayTrigger>
                                </div>
                            </InputGroup>
                        </Form>
                    </div> : ''}
                    {btnType == "yourself" && contentData.coverimage ? <div className="mt-3"><img src={contentData.coverimage} alt="cover image" width="100%" height="298px" /></div> : ''}
                    {btnType == "external" ? 
                       <div>
                            <div className="d-flex mt-3" style={{ width: "60%" }}>
                                <Form.Control id="blog" name="blog" value={urlLink} placeholder="paste the url for blog" onChange={(e) => setUrlData(e.target.value)} />
                                <div className="d-flex w-100">
                                    <Button className="clickable" style={{ marginLeft: "10px", borderRadius: "5px", width: "40%" }} onClick={() => getUrlData(urlLink)} disabled={spinnerLoading || removeBlogLoading}>Add to Blog {spinnerLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }</Button>
                                    <Button className="clickable" style={{ marginLeft: "10px", borderRadius: "5px", width: "40%" }} onClick={() => removeUrlData(urlLink)} disabled={spinnerLoading || removeBlogLoading}>Remove Blog {removeBlogLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }</Button>
                                </div>
                            </div>
                            {contentData.coverimage ? 
                                <div className="mt-3">
                                    <img src={contentData.coverimage} alt="cover image" width="100%" height="298px" />
                                </div> : ''}
                       </div>
                    : ''}
                    {coverImgError.msg ? <div className="font-weight-bold mt-3" style={{ color: coverImgError.type === "success" ? "green" : coverImgError.type === "error" ? "red" : "" }}>{coverImgError.msg}</div> : ''}
                    <div>
                        {btnType == "yourself" ? <label className='font-weight-bold mt-3'>Title*</label> : <label className='font-weight-bold mt-3'>Blog Title</label>}
                        <div className="text-editor">
                            <div className="wrapper">
                                <ReactQuill theme="snow"
                                    modules={quillModules}
                                    placeholder="Type your news/story title here"
                                    value={contentData.title}
                                    onChange={(e) => setNewsStoriesData("title", e)} />
                            </div>
                        </div>
                        {titleError ? <div className="d-flex align-items-center justify-content-center mb-3" style={{ color: 'red', fontWeight: "bold" }}>{titleError}</div> : ''}
                    </div>
                    <div>
                        <label className='font-weight-bold'>Summary*</label>
                        <div className="text-editor">
                            <div className="wrapper">
                                <ReactQuill theme="snow"
                                    modules={quillModules}
                                    placeholder="Type your news/story summary here"
                                    value={contentData.summary}
                                    onChange={(e) => setNewsStoriesData("summary", e)} />
                            </div>
                        </div>
                    </div>
                    {summaryError ? <div className="d-flex align-items-center justify-content-center mb-3" style={{ color: 'red', fontWeight: "bold" }}>{summaryError}</div> : ''}
                    {btnType == "yourself" ? <div>
                        <label className='font-weight-bold'>Story</label>
                        <Form.Group className="d-flex">
                            <Form.Check className='radio-items' type="radio" id="custom" name="custom" label="Custom" value="custom" checked={radioBtnChecked === 'custom'} onChange={(event => radiobtnChange("custom", event))} />
                            <Form.Check className='radio-items' type="radio" id="external" name="external" label="External Link" value="external" checked={radioBtnChecked === 'external'} onChange={(event => radiobtnChange("external", event))} />
                        </Form.Group>  
                    </div> : ''}

                    { btnType == "yourself" && radioBtnChecked == "custom" ? <div>
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="d-flex align-items-center justify-content-end" style={{ backgroundColor: "#FFFFFF" }}>
                                <div>
                                    <img src={`/static/icons/table/view.svg`} alt="view" height="25px" width="25px" className="action-button" onClick={() => showViewModal(true)} />
                                </div>
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" height="25px" width="25px" className="action-button" onClick={() => setDescriptionModal(true)} />
                                </div>
                            </div>
                        </div>
                        <div className="text-editor clickable">
                            <div className="templateClass" style={{ width: "100%", border:  "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#FFFFFF" }}>
                                <div style={{ height: "100px", padding: "0.375rem 0.75rem", overflowY: "scroll" }} onClick={() => {setDescriptionModal(true)}}>
                                    {contentData.htmlcontent && contentData.htmlcontent !== '{}' ?
                                    <div style={{ paddingRight: "4%" }} dangerouslySetInnerHTML={{ __html: contentData.htmlcontent }} /> : ''}
                                </div>
                            </div>
                        </div>
                    </div> : btnType == "yourself" && radioBtnChecked == "external" ? 
                    <div>
                        <label className='font-weight-bold'>Link</label>
                        <div className="text-editor">
                            <Form.Control type="text" id="storylink" name="storylink" value={contentData.storylink} placeholder=" " onChange={(e) => setNewsStoriesData("storylink", e.target.value)} />
                        </div>
                    </div> : ''}
                    { btnType == "external" ?
                        <div>
                            <label className='font-weight-bold'>Link</label>
                            <div className="text-editor">
                                <Form.Control type="text" id="storylink" name="storylink" value={urlLink} placeholder=" " onChange={(e) => setNewsStoriesData("storylink", e.target.value)} disabled />
                            </div>
                        </div> : ''
                    }
                    <div>
                        <label className='font-weight-bold mt-3'>Reference / Citation Link</label>
                        <div className="text-editor">
                            <Form.Control as="textarea" id="referenceLink" name="referenceLink" value={contentData.referenceLink} placeholder=" " onChange={(e) => setNewsStoriesData("referenceLink", e.target.value)} />
                        </div>
                    </div>
                    <div>
                        <label className='font-weight-bold mt-3'>Author*</label>
                        <div className="text-editor">
                            <Form.Control type="text" id="publishername" name="publishername" value={contentData.publishername} placeholder=" " onChange={(e) => setNewsStoriesData("publishername", e.target.value)} />
                        </div>
                    </div>
                </div>
                {savedMsg.msg ? <div className="d-flex align-items-center justify-content-center font-weight-bold mt-5" style={{ color: savedMsg.type === "success" ? "green" : savedMsg.type === "error" ? "red" : "" }}>{savedMsg.msg}</div> : ''}
                <div className="d-flex align-items-center justify-content-between px-5 mb-5 mt-5 mobile-btn" style={{ gap: "15px" }}>
                    <Button style={{ borderRadius: "5px", width: "50%" }} onClick={() => {previewStories()}} disabled={ !isFormValid || coverImgError.msg || titleError || summaryError || saveLoading }>Preview</Button>
                    <Button style={{ borderRadius: "5px", width: "50%" }} disabled={  saveLoading } onClick={cancelStories}>Cancel</Button>
                    <Button style={{ borderRadius: "5px", width: "50%" }} onClick={() => {publishStories("draft")}} disabled={ !isFormValid || coverImgError.msg || titleError || summaryError || saveLoading }>Save as Draft</Button>
                    <Button style={{ borderRadius: "5px", backgroundColor: "#a50050", width: "50%" }} 
                        onClick={() => {publishStories("publish")}} disabled={ !isFormValid || coverImgError.msg || titleError || summaryError || saveLoading }>Publish { saveLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }</Button>
                    <div style={{ position: "relative", display: "inline-block", width: "50%" }}>
                        <Button style={{ borderRadius: "5px", backgroundColor: "#a50050", width: "100%" }} disabled={ !isFormValid || coverImgError.msg || titleError || summaryError || saveLaterLoading || saveLoading } onClick={() => setShowDatePicker((prev) => !prev)}>
                            Schedule Later  { saveLaterLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : '' }
                        </Button>

                        {showDatePicker && (
                            <div style={{ position: "absolute", top: "45px", zIndex: 100 }}>
                            <DatePicker style={{ display: "flex !important" }}
                                placeholder="Select date and time"
                                selected={selectedDate}
                                onChange={(date) => handleDateChange(date)}
                                showTimeSelect
                                timeIntervals={15}
                                timeFormat="hh:mm a"
                                inline
                                dateFormat="MM/dd/yyyy hh:mm a"
                                minDate={new Date()}
                                filterTime={filterPassedTime}
                                popperPlacement="bottom"
                                popperModifiers={[
                                    {
                                    name: 'offset',
                                    options: {
                                        offset: [0, 10],
                                    },
                                    },
                                ]}
                            />
                            </div>
                        )}
                    </div>
                </div>

                <Modal show={showMediaModal} size="lg" animation={false} onHide={() => {setShowMediaModal(false)}}>
                    <Modal.Header>
                        <Button type="button" onClick={cancelImage} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                        <div className={'doka-profile-layout'} style={{ width: '100%' }}>
                            <DokaImageEditor {...getEditorDefaults(bgTargetImage)}
                                {...bgImageEditorDefaults} src={tempBgImg} onProcess={setNewsStoriesBgData} />
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={previewModal} size="lg" animation={false} onHide={() => {showPreviewModal(false)}}>
                    <Modal.Header className='align-items-end justify-content-end clickable'>
                        <div className="close-icon" onClick={() => { showPreviewModal(false) }}></div>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            contentData ? 
                            <div className="w-100 d-flex flex-column p-3 clickable" style={{ gap: "10px" }}>
                                <div className="w-100 d-flex justify-content-center">
                                    <img style={{ height: "200px", width: "100%" }} src={contentData.coverimage ? contentData.coverimage : ''} alt="news-stories-img" />
                                </div>
                                <div className="w-70 d-flex flex-column" style={{ padding: "0 10%" }}>
                                    <div className="mt-3" style={{ fontSize: "16px", fontWeight: "bold", lineHeight: "24px" }} dangerouslySetInnerHTML={{ __html:contentData.title}} />
                                    <div className="mt-3" style={{ borderTop: "1px solid #00263E", width: "100%" }} />
                                    <div className="d-flex flex-row mt-3">
                                        <div>By &nbsp;</div> <div dangerouslySetInnerHTML={{ __html:contentData.publishername}} />
                                    </div>
                                    <div className="mt-5" style={{ fontSize: "14px", lineHeight: "20px" }} dangerouslySetInnerHTML={{ __html:contentData.summary}} />
                                    <div className="mt-3" style={{ fontSize: "14px", lineHeight: "20px" }} dangerouslySetInnerHTML={{ __html:contentData.htmlcontent}} />
                                    <div className="mt-3" style={{ fontSize: "14px", lineHeight: "20px" }} dangerouslySetInnerHTML={{ __html:contentData.storylink }} />
                                    <div className="mt-3" style={{ fontSize: "14px", lineHeight: "20px" }} dangerouslySetInnerHTML={{ __html:contentData.referenceLink }} />
                                </div>
                            </div>
                            : <div className="d-flex align-items-center justify-content-center">No data to preview</div>
                        }   
                    </Modal.Body>
                </Modal>

                <Modal show={descriptionModal} size="lg" animation={false} onHide={() => {setDescriptionModal(false)}}>
                    <Modal.Header className='align-items-end justify-content-end clickable'></Modal.Header>
                    <Modal.Body>
                        <div className="wrapper-desc">
                            <ReactQuill theme="snow"
                                modules={quillModules}
                                placeholder="Type your news/story content here"
                                value={descriptionContent ? descriptionContent : contentData.htmlcontent}
                                onChange={(e) => onChangeDescriptionContent(e)} />
                        </div>
                        <div className="d-flex" style={{ margin: "1% 3%", float: "right" }}>
                            <Button style={{ marginRight: "4%", backgroundColor: '#00263E ' }} onClick={ () => {cancelDescription()} }>Cancel</Button>
                            <Button className="save-button" onClick={() => {saveDescription()}}>Save</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal id="description" show={viewModal} size="lg" animation={false} onHide={() => { showViewModal(false) }} keyboard={false}>
                    <Modal.Body className="templateClass">
                        {
                            <div className="ql-editor" style={{ padding: "1rem" }} dangerouslySetInnerHTML={{ __html: contentData.htmlcontent }} />
                        }
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={() => {showViewModal(false) }}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
    )
}